import {
  allFonts,
  fontFamilyAliases,
  parseFamilyChain,
  pickerFonts,
} from '@messenger/lotus/fonts'

const PICKABLE: ReadonlySet<string> = new Set<string>(
  pickerFonts.map((f) => f.name),
)

const allFontNamesLower = new Map<string, string>()
for (const row of fontFamilyAliases)
  allFontNamesLower.set(row.alias, row.family_name)
for (const font of allFonts) {
  if (font.displayName)
    allFontNamesLower.set(font.displayName.toLowerCase(), font.name)
  allFontNamesLower.set(font.name.toLowerCase(), font.name)
}

/**
 * The picker font a family name `parseFamilyChain` read names. The name is
 * already unquoted, so a quote left in it belongs to the name; padding inside
 * its quotes is ignored.
 */
const matchCatalogFamily = (family: string): string | undefined => {
  const cleaned = family.trim()
  const matched = cleaned
    ? allFontNamesLower.get(cleaned.toLowerCase())
    : undefined
  return matched && PICKABLE.has(matched) ? matched : undefined
}

export const canonicalFontName = (rawFontName: string): string | undefined => {
  for (const family of parseFamilyChain(rawFontName)) {
    const matched = matchCatalogFamily(family)
    if (matched) return matched
  }
  return undefined
}

export const extractFontFamiliesFromHtml = (html: string): Set<string> => {
  const fonts = new Set<string>()
  const styleRegex = /style\s*=\s*"([^"]*)"/gi
  let styleMatch: RegExpExecArray | null

  while ((styleMatch = styleRegex.exec(html)) !== null) {
    const styleValue = styleMatch[1]
      .replace(/&quot;/gi, '"')
      .replace(/&#0*39;/g, "'")
      .replace(/&amp;/gi, '&')
    const fontFamilyRegex = /font-family:\s*([^;]+)/gi
    let fontMatch: RegExpExecArray | null

    while ((fontMatch = fontFamilyRegex.exec(styleValue)) !== null) {
      for (const family of parseFamilyChain(fontMatch[1])) {
        const matched = matchCatalogFamily(family)
        if (matched) fonts.add(matched)
      }
    }
  }

  return fonts
}
